// @flow
import * as React from 'react';
import { Box } from 'gestalt';

type Props = {|
  children: React.Node,
|};

export const List = ({ children }: Props) => (
  <Box width="100%" role="list">
    {children}
  </Box>
);

export default List;
